import type { Dispatch, SetStateAction } from 'react'
import type { FamilyEditorSchemaDto } from './types'
import { FamilyEditorFieldsSection } from './FamilyEditorFieldsSection'
import { FamilyEditorPricingSection } from './FamilyEditorPricingSection'

export interface FamilyEditorSidebarContentProps {
  projectId: string
  quoteId: string | null
  versionId: string | null
  familyKey: string | null
  schema: FamilyEditorSchemaDto | null
  isLoading: boolean
  error: string | null
  missingRequiredFields: Array<{ id: string; label: string }>
  missingRequiredFieldIds: string[]
  allVisibleFields: FamilyEditorSchemaDto['fields']
  values: Record<string, unknown>
  onChangeValues: Dispatch<SetStateAction<Record<string, unknown>>>
  isFieldRequired: (field: FamilyEditorSchemaDto['fields'][number]) => boolean
  quantity: number | null
  onQuantityChange: (next: number | null) => void
  unitPrice: number | null
  onUnitPriceChange: (next: number | null) => void
  vatPercent: number | null
  onVatPercentChange: (next: number | null) => void
  priceIncluded: boolean
  onPriceIncludedChange: (next: boolean) => void
}

export function FamilyEditorSidebarContentFallback({
  schema,
  isLoading,
  error,
  missingRequiredFields: _missingRequiredFields,
  missingRequiredFieldIds,
  allVisibleFields,
  values,
  onChangeValues,
  isFieldRequired,
  quantity,
  onQuantityChange,
  unitPrice,
  onUnitPriceChange,
  vatPercent,
  onVatPercentChange,
  priceIncluded,
  onPriceIncludedChange,
}: FamilyEditorSidebarContentProps) {
  return (
    <div className="flex-1 overflow-y-auto px-4 py-4">
      {isLoading ? (
        <div className="py-10 text-center text-sm text-muted-foreground">Chargement...</div>
      ) : !schema ? (
        error ? (
          <div className="rounded-md border border-destructive/30 bg-destructive/5 px-4 py-3">
            <p className="text-sm text-muted-foreground">{error}</p>
          </div>
        ) : null
      ) : (
        <div className="space-y-3">
          <div className="space-y-6">
            {error ? (
              <div className="rounded-md border border-destructive/30 bg-destructive/5 px-4 py-3">
                <p className="text-sm text-muted-foreground">{error}</p>
              </div>
            ) : null}

            <div className="space-y-3">
              <FamilyEditorFieldsSection
                title=""
                fields={allVisibleFields}
                values={values}
                onChangeValues={onChangeValues}
                missingFieldIds={missingRequiredFieldIds}
                isFieldRequired={isFieldRequired}
              />

              <FamilyEditorPricingSection
                schema={schema}
                quantity={quantity}
                onQuantityChange={onQuantityChange}
                unitPrice={unitPrice}
                onUnitPriceChange={onUnitPriceChange}
                vatPercent={vatPercent}
                onVatPercentChange={onVatPercentChange}
                priceIncluded={priceIncluded}
                onPriceIncludedChange={onPriceIncludedChange}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
